import { render, staticRenderFns } from "./ModalAcceptInvitations.vue?vue&type=template&id=482203fa"
import script from "./ModalAcceptInvitations.vue?vue&type=script&lang=js"
export * from "./ModalAcceptInvitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports